import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
export const _frontmatter = {
  "title": "Contact",
  "icon": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const NetlifyForm = makeShortcode("NetlifyForm");
const TextInput = makeShortcode("TextInput");
const InputLabel = makeShortcode("InputLabel");
const InputAnnounce = makeShortcode("InputAnnounce");
const TextArea = makeShortcode("TextArea");
const Button = makeShortcode("Button");
const Spinner = makeShortcode("Spinner");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Contact`}</h1>
    <p>{`GatStats provides a number of form short codes for use in `}<inlineCode parentName="p">{`.mdx`}</inlineCode>{`, see the Storybook links below`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://gatsby-theme-gatstats.netlify.com/storybook/?path=/story/textinput--usage"
        }}>{`TextInput`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://gatsby-theme-gatstats.netlify.com/storybook/?path=/story/textarea--usage"
        }}>{`TextArea`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://gatsby-theme-gatstats.netlify.com/storybook/?path=/story/inputannounce--usage"
        }}>{`InputAnnounce`}</a></li>
    </ul>
    <p>{`If you use the `}<a parentName="p" {...{
        "href": "(https://gatsby-theme-gatstats.netlify.com/storybook/?path=/story/netlifyform--usage)"
      }}>{`NetlifyForm`}</a>{` component you can setup serverless forms using Netlify's `}<a parentName="p" {...{
        "href": "https://www.netlify.com/products/forms/"
      }}>{`built-in form service`}</a>{`, and here's the `}<a parentName="p" {...{
        "href": "https://github.com/PaulieScanlon/gatsby-theme-gatstats/blob/master/demo/src/pages/contact.mdx"
      }}>{`source code`}</a>{` including `}<a parentName="p" {...{
        "href": "https://jaredpalmer.com/formik/"
      }}>{`Formik`}</a>{` setup and `}<a parentName="p" {...{
        "href": "https://github.com/jquense/yup"
      }}>{`Yup`}</a>{` validation used to create the contact form on this page.`}</p>
    <Formik initialValues={{
      name: '',
      email: '',
      message: ''
    }} validationSchema={Yup.object().shape({
      name: Yup.string().required('Please enter a name'),
      email: Yup.string().email().required('Please enter an email address'),
      message: Yup.string().required('Please enter a message')
    })} onSubmit={(values, {
      setSubmitting,
      resetForm
    }) => {
      const encode = data => {
        return Object.keys(data).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');
      };

      fetch('/?no-cache=1', {
        method: "POST",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: encode({
          "form-name": "contact",
          ...values
        })
      }).then(() => {
        setTimeout(() => {
          setSubmitting(false);
          resetForm();
        }, 2000);
      }).catch(error => {
        console.log('form error: ', error);
        setSubmitting(false);
      });
    }} mdxType="Formik">
  {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => {
        return <NetlifyForm name="contact" onSubmit={handleSubmit} mdxType="NetlifyForm">
        <TextInput type='hidden' name='bot-field' mdxType="TextInput" />
        <InputLabel htmlFor='name' mdxType="InputLabel">Your name</InputLabel>
        <TextInput name="name" placeholder="Paul" value={values.name} onChange={handleChange} onBlur={handleBlur} mdxType="TextInput" />
        {errors.name && touched.name ? <InputAnnounce mdxType="InputAnnounce">{errors.name}</InputAnnounce> : null}
        <InputLabel htmlFor='email' mdxType="InputLabel">Your email</InputLabel>
        <TextInput name="email" type="email" placeholder="paul@email.com" value={values.email} onChange={handleChange} onBlur={handleBlur} mdxType="TextInput" />
        {errors.email && touched.email ? <InputAnnounce mdxType="InputAnnounce">{errors.email}</InputAnnounce> : null}
        <InputLabel htmlFor='message' mdxType="InputLabel">Your message</InputLabel>
        <TextArea name="message" placeholder="Hello there!" value={values.message} onChange={handleChange} onBlur={handleBlur} mdxType="TextArea" />
        {errors.message && touched.message ? <InputAnnounce mdxType="InputAnnounce">{errors.message}</InputAnnounce> : null}
        <div style={{
            height: 24
          }} />
        <Button type="submit" disabled={isSubmitting || errors.name || errors.email || errors.message} mdxType="Button">
        {isSubmitting ? <Spinner mdxType="Spinner" /> : 'Submit'}
        </Button>
        <div style={{
            height: 48
          }} />
      </NetlifyForm>;
      }}
    </Formik>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      